/**
 * A origem do metodo na aviacao.
 *
 * Todo numero aqui foi conferido na publicacao original e esta registrado em
 * 02-referencias/dados-verificados.md, com link para a fonte. Nada veio de
 * resumo de terceiro.
 *
 * Cuidado de precisao que vale manter: e comum ler que a causa raiz de
 * Tenerife foi falha de comunicacao. O relatorio oficial atribui o acidente
 * primariamente as acoes do comandante, e a ambiguidade de comunicacao entra
 * como fator determinante. A redacao abaixo respeita essa diferenca, porque o
 * publico tem gente de qualidade e gestao de riscos que percebe.
 *
 * O terceiro marco foi atualizado em 19/10 com o roteiro do grupo: alem do
 * estudo de 2009-2013, entra o acompanhamento de dez anos publicado em 2025,
 * que e o que sustenta a frase "o problema persiste". A fonte passa a aparecer
 * na pagina, e nao so neste comentario: numero sem fonte, num publico de
 * seguranca do paciente, vira objecao em vez de argumento.
 */
export interface Marco {
  ano: string;
  titulo: string;
  texto: string;
}

export const marcos: Marco[] = [
  {
    ano: '1977',
    titulo: 'Tenerife',
    texto:
      'Dois Boeing 747 colidem na pista de Los Rodeos, resultando em 583 mortes. O comandante iniciou a decolagem tendo recebido autorização de rota, não de decolagem. Entre as causas determinantes está a ambiguidade da comunicação com a torre. A investigação evidencia fatores que mudariam a abordagem da segurança na aviação: comunicação, hierarquia, consciência situacional e tomada de decisão também influenciam resultados.',
  },
  {
    ano: '1979',
    titulo: 'O método nasce',
    texto:
      'A NASA reúne pesquisadores e profissionais da aviação para estudar o papel dos fatores humanos nos acidentes. Os estudos identificam a recorrência de problemas de comunicação, liderança, tomada de decisão e coordenação das equipes. Nasce o Crew Resource Management: uma abordagem voltada ao uso mais efetivo de todos os recursos disponíveis, pessoas, informações e equipamentos, especialmente em situações críticas.',
  },
  {
    ano: '2014\u00a0a\u00a02024',
    titulo: 'O mesmo desafio na saúde',
    texto:
      'Em uma análise nacional conduzida pela CRICO Strategies, vinculada ao sistema de gestão de riscos da comunidade médica de Harvard, foram avaliados 23.658 casos de alegações de má prática assistencial registrados entre 2009 e 2013. Falhas de comunicação foram identificadas em 30% dos casos e, entre aqueles com danos de maior gravidade, esse percentual chegou a 37%. No conjunto analisado, problemas de comunicação estiveram associados a 1.744 mortes e a 1,7 bilhão de dólares em perdas. Dez anos depois, o problema persiste: o relatório de acompanhamento publicado pela Candello e CRICO em 2025 analisou casos entre 2014 e 2024 e identificou fatores relacionados à comunicação em 40% deles, ante 30% na análise anterior.',
  },
];

/** A fonte do terceiro marco, na pagina e nao so no codigo. */
export const fonteDaConta =
  'CANDELLO. Malpractice Risks in Communication Failures: A 10-Year Follow Up. CRICO, 2025. O relatório utiliza a base nacional Candello, que reúne cerca de um terço dos casos de responsabilidade profissional médica abertos e encerrados nos Estados Unidos.';

/** O remate do bloco, antes da ressalva. */
export const remateDaConta =
  'A tecnologia evoluiu. Os processos mudaram. Mas a comunicação continua sendo uma vulnerabilidade relevante para a segurança do paciente.';

/** O que a pagina precisa dizer logo depois dos marcos, para nao virar copia. */
export const ressalva = {
  titulo: 'A aviação é a origem. Não o modelo a ser copiado.',
  texto:
    'Aviação, energia nuclear e outras indústrias de alto risco desenvolveram estratégias para lidar com erro, incerteza e variabilidade humana. Na saúde, esses princípios precisam ser traduzidos, não simplesmente transferidos. Equipes multiprofissionais, hierarquia, alta variabilidade, múltiplas transições de cuidado e decisões simultâneas tornam o hospital um sistema complexo com características próprias.',
  remate: 'É nessa tradução que nasce o HCRM.',
} as const;
